export default "__VITE_ASSET__CIDFjjsD__"